$('document').ready(function(){
  show_active_filters_title();
  filter_select();
  mobile_filtering_alteration();
})

function show_active_filters_title(){
  var url=location.href;
  if(url.includes('?filter')){
//      $('.active-filter-content-header').show();
    $('.active-filters').show();
  }
  else{
//      $('.active-filter-content-header').hide();
    $('.active-filters').hide();
  }
}

function filter_select(){
  $('.filter-group-display__list-item .filter-checkbox').each(function (){
    $(this).change(function(){
      check_all_selected();
      $('.filter-form').submit();
    });
  });
}

function check_all_selected(){
  var count=0;
  $('.filter-group-display__list .filter-checkbox').each(function (){
    if($(this).prop('checked')){
      count+=1;
//      $('.active-filter-content-header').show();
      $('.active-filters').show();
    }
  });
  $('.filter-group-display__header-selected').html(count+' selected');
  if(count==0){
//      $('.active-filter-content-header').hide();
    $('.active-filters').hide();
  }
}

function mobile_filtering_alteration(){
  $('.ced-mobile-filter-title').click(function(){
   $('body').addClass('open-filter');
  });
  $('.filter-title').click(function(){
    $('body').removeClass('open-filter');
  });
}